import { Team, User } from 'api/models';

type ActiveUsersTeamsType = {
  users: User[];
  teams: Team[];
};

export class ActiveUsersAndTeams {
  private _activeUsersAndTeams: ActiveUsersTeamsType = {
    teams: [],
    users: [],
  };

  get getActiveUsersAndTeams(): ActiveUsersTeamsType {
    return this._activeUsersAndTeams;
  }

  set setActiveUsersAndTeams(value: ActiveUsersTeamsType) {
    this._activeUsersAndTeams = value;
  }
}
